import { Navigate } from "react-router-dom";


export const PrivateRoute = ({children}) => {
    const getTokenFromLocalStorage = JSON.parse(localStorage.getItem("user"))
    return getTokenFromLocalStorage?.token !== undefined ? children : (<Navigate to='/login' replace={true} />)
}


export const PrivateCheckoutRoute = ({children}) => {
    const getCartItemFromLocalStorage = JSON.parse(localStorage.getItem("cartItem"))
    return getCartItemFromLocalStorage?.cartItem !== undefined ? children : (<Navigate to='/buy-macrum' replace={true} />)
}
